import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { withRouter, useLocation } from "react-router-dom"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { Card, CardBody, Col, Row } from "reactstrap"
import { useSelector, useDispatch } from "react-redux"

import {
  getInvoiceHistoryes as onGetInvoiceHistoryes,
  getInvoiceHistoryesSuccess,
} from "store/actions"

import Columns from "./Columns"
import { expandRow } from "./invoieHistoryDetails"
import PayInvoiceModal from "./payInvoiceModel"

const InvoiceHistory = props => {
  const { orderObject, isOpen, user } = props
  const dispatch = useDispatch()
  let location = useLocation()

  const { invoiceHistoryes } = useSelector(state => ({
    invoiceHistoryes: state.invoiceHistoryes.invoiceHistoryes,
  }))

  const [localInvoices, setLocalInvoices] = useState({ docs: [] })
  const [payInvoiceModal, setPayInvoiceModal] = useState(false)
  const [selectedRec, setSelectedRec] = useState(null)

  // pagination state
  const [page, setPage] = useState(1)
  const [sizePerPage, setSizePerPage] = useState(20)

  // pagination options (will be updated when API responds)
  const pageOptions = {
    custom: true,
    sizePerPage,
    page,
    totalSize: invoiceHistoryes?.totalDocs || 0,
  }

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]

  // Build API filter
  function filterFunction(page) {
    const queryParams = new URLSearchParams(location.search)
    const params = {
      userName: orderObject.userName,
      id: orderObject._id,
      paymentStatus: false,
      delete: "false",
    }

    for (let [key, value] of queryParams.entries()) {
      params[key] = value
    }

    params.page = page
    delete params.size

    return { params, paginate: { size: sizePerPage, page } }
  }

  // fetch data
  const handlePage = (page, sizePerPage) => {
    setPage(page)
    setSizePerPage(sizePerPage)
    const json = filterFunction(page)
    json.paginate = { size: sizePerPage, page }
    dispatch(onGetInvoiceHistoryes(json))
  }

  // when redux state updates
  useEffect(() => {
    if (invoiceHistoryes?.docs) {
      setLocalInvoices(invoiceHistoryes)
    }
  }, [invoiceHistoryes])

  // reset on close
  useEffect(() => {
    if (!isOpen) {
      dispatch(getInvoiceHistoryesSuccess([]))
      setLocalInvoices({ docs: [] })
    } else {
      handlePage(1, sizePerPage)
    }
  }, [isOpen])

  const togglePayInvoiceModel = () => setPayInvoiceModal(!payInvoiceModal)
  const toggleModal = row => {
    setSelectedRec(row)
    togglePayInvoiceModel()
  }
  const onClickDelete = row => console.log("delete", row)

  return (
    <React.Fragment>
      <PayInvoiceModal
        isOpen={payInvoiceModal}
        toggle={togglePayInvoiceModel}
        processData={selectedRec}
      />

      <PaginationProvider pagination={paginationFactory(pageOptions)}>
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="_id"
            data={localInvoices.docs || []}
            columns={Columns(toggleModal, onClickDelete, user)}
            bootstrap4
          >
            {toolkitProps => (
              <>
                <Row>
                  <Col xl="12">
                    <div className="table-responsive">
                      <BootstrapTable
                        remote={{ pagination: true }}
                        keyField="_id"
                        data={localInvoices.docs || []}
                        columns={Columns(toggleModal, onClickDelete, user)}
                        bordered={false}
                        striped={false}
                        defaultSorted={defaultSorted}
                        classes="table align-middle table-nowrap table-check"
                        headerWrapperClasses="table-light"
                        {...toolkitProps.baseProps}
                        {...paginationTableProps}
                        expandRow={expandRow}
                        onTableChange={(type, { page, sizePerPage }) =>
                          handlePage(page, sizePerPage)
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="align-items-md-center mt-30">
                  <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                    <PaginationListStandalone {...paginationProps} />
                  </Col>
                </Row>
              </>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    </React.Fragment>
  )
}

InvoiceHistory.propTypes = {
  orderObject: PropTypes.object,
  isOpen: PropTypes.bool,
  user: PropTypes.bool,
}

export default withRouter(InvoiceHistory)
